var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortalDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 112,
    viewBox: "0 0 253 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19899_1438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6835 -294.962C102.761 -345.253 239.96 -340.898 297.09 -324.998C354.22 -309.098 361.452 -258.998 386.461 -199.56C411.47 -140.123 418.818 46.9841 375.725 92.369C313.359 114.778 138.032 44.38 49.385 68.7772C-32.3641 91.276 -120.765 129.991 -88.2264 73.1496",
    fill: "url(#paint0_linear_19899_1438)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19899_1438",
    x: -99.3416,
    y: -335.779,
    width: 510.189,
    height: 446.868,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19899_1438"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19899_1438",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19899_1438",
    x1: 37.8483,
    y1: 36.4526,
    x2: 267.472,
    y2: -23.3095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A180FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortalDashboard);
export default __webpack_public_path__ + "static/media/portal_dashboard.3a6eef4c34670cf3f79535a2fef504de.svg";
export { ForwardRef as ReactComponent };